import XhrRequestHandler from '../../lib/XhrRequestHandler';
import { Arbitro, ArbitroJSON } from './Arbitro';
export class ArbitroSystem {
    private readonly base = '/arbitros';
    constructor(private requestHandler: XhrRequestHandler) {
    }

    async getArbitroIdentifiedBy(id: string): Promise<Arbitro> {
        const data = await this.requestHandler.get<ArbitroJSON>(`${this.base}/${id}`);
        return Arbitro.fromJSON(data);
    }

    async getList(): Promise<Arbitro[]> {
        const data = await this.requestHandler.get<ArbitroJSON[]>(`${this.base}`);
        return data.map((entity) => Arbitro.fromJSON(entity))
    }

    async getListForDropdown(): Promise<Arbitro[]> {
        const data = await this.requestHandler.get<ArbitroJSON[]>(`${this.base}/for-dropdown`);
        return data.map((entity) => Arbitro.fromJSON(entity))
    }

    async save(entity: Arbitro) {
        const data = entity.toJSON();
        const savedEntity = await this.requestHandler.post<ArbitroJSON, ArbitroJSON>(this.base, data);
        return Arbitro.fromJSON(savedEntity);
    }

    getBaseUrlForDatagrid() {
        return this.requestHandler.requestUrl(`${this.base}/datagrid`)
    }

}

